import Preview from '#components/side-preview.jsx';
import { cn } from '#lib/helpers/class.js';
import { useEffect, useRef, useState } from 'react';
import IframePreview from './iframe-preview.jsx';

export function ItineraryPreview(props) {
    const { previewData, activeProfile, anchorPlan, showItineraryPreview, onOpenPreview, onClosePreview } = props;
    const heightPreview = 'calc(100vh - 112px)';
    const heightFullPreview = 'calc(100vh - 56px)';
    const now = useRef(Date.now());
    const [isSmallScreen, setIsmallScreen] = useState(window.innerWidth < 1060);
    const [fullScreen, setFullScreen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (!isSmallScreen && window.innerWidth < 1060 && showItineraryPreview && !fullScreen) {
                onClosePreview();
            }
            setIsmallScreen(window.innerWidth < 1060);
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    });

    const [themeId, setThemeId] = useState(activeProfile?.styles?.themeId);
    useEffect(() => {
        setThemeId(activeProfile?.styles?.themeId);
    }, [activeProfile]);

    return (
        <Preview>
            <div
                className={cn(
                    'fixed right-0 h-full bg-neutral-100 z-40',
                    showItineraryPreview
                        ? fullScreen
                            ? `${isSmallScreen ? 'w-[88vw]' : 'w-[96vw]'} top-[56px]`
                            : 'w-1/3 top-[112px]'
                        : 'w-0 top-[112px]'
                )}
                style={{
                    height: fullScreen ? heightFullPreview : heightPreview
                }}
            >
                {activeProfile && themeId && (
                    <IframePreview
                        src={`${MEDIA_URL}/media/theme/${themeId}/source/client/index.html?guid=${now?.current}${anchorPlan}`}
                        className="relative z-10 border border-neutral-200"
                        style={{
                            minWidth: '100%',
                            height: '100%'
                        }}
                        options={activeProfile}
                        itinerary={previewData}
                        show={showItineraryPreview}
                    />
                )}

                {!isSmallScreen && (
                    <Preview.OpenButton
                        className={cn(
                            'absolute -rotate-90 -left-[68px] hover:-left-[76px] w-28 pb-4 pt-2 bg-white border border-neutral-200 rounded-t-lg text-sm text-neutral-700 font-semibold transition-all shadow-md hover:bg-neutral-100 -z-50',
                            showItineraryPreview && !fullScreen ? 'hidden' : 'visible',
                            fullScreen ? 'top-[160px]' : 'top-[36px]'
                        )}
                        onClick={() => {
                            onOpenPreview();
                            setFullScreen(false);
                        }}
                    >
                        {_t.edit.openPreview()}
                    </Preview.OpenButton>
                )}
                <Preview.OpenButton
                    className={cn(
                        'absolute -rotate-90 -left-[68px] hover:-left-[76px] w-28 pb-4 pt-2 bg-white border border-neutral-200 rounded-t-lg text-sm text-neutral-700 font-semibold transition-all shadow-md hover:bg-neutral-100 -z-50',
                        fullScreen ? 'hidden' : 'visible',
                        isSmallScreen ? 'top-[36px]' : 'top-[160px]'
                    )}
                    onClick={() => {
                        onOpenPreview();
                        setFullScreen(true);
                    }}
                >
                    {_t.edit.fullScreen()}
                </Preview.OpenButton>
                <Preview.CloseButton
                    className={cn(
                        'absolute -rotate-90 top-[36px] -left-[68px] hover:-left-[76px] w-28 pb-4 pt-2 bg-white border border-neutral-200 rounded-t-lg text-sm text-neutral-700 font-semibold transition-all shadow-md hover:bg-neutral-100 -z-50',
                        showItineraryPreview ? 'visible' : 'hidden'
                    )}
                    onClick={() => {
                        onClosePreview();
                        setFullScreen(false);
                    }}
                >
                    {_t.edit.closePreview()}
                </Preview.CloseButton>
            </div>
        </Preview>
    );
}
